import React from 'react'
import NewBreadCrumbs from '../../../@core/components/breadcrumbs/NewBreadCrumbs'
import DetailsPricesAndList from './details/DetailsPricesAndList'

const PriceList = () => {
    return (
        <>
            <NewBreadCrumbs title={'Listini'}></NewBreadCrumbs>
            <DetailsPricesAndList></DetailsPricesAndList>
        </>
    )
}

export default PriceList